module.exports = __webpack_public_path__ + "static/media/bg-contacto.833668da.jpg";